import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function VerifySubscription() {
  const { token } = useParams();

  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");

  useEffect(() => {
    axios
      .get(`https://jumeiradiscounthotels.com/api/subscribe/verify/${token}`)
      .then((res) => {
        console.log("VERIFY RESPONSE:", res.data);
        setStatus("success");
        setEmail(res.data.email);
      })
      .catch(() => {
        setStatus("error");
      });
  }, [token]);

  // const handleUnsubscribe = () => {
  //   if (!email) {
  //     console.log("Email is missing!");
  //     return;
  //   }

  //   axios.post(`https://jumeiradiscounthotels.com/api/subscribe/unsubscribe`, {
  //     token: token,
  //   })
  //     .then(() => {
  //       setStatus("unsubscribed");
  //     })
  //     .catch((err) => {
  //       console.log(err.response?.data);
  //     });
  // };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-md border p-8 max-w-md w-full text-center">

        {/* Loading */}
        {status === "loading" && (
          <p className="text-gray-500">Verifying...</p>
        )}

        {/* Success */}
        {status === "success" && (
          <div>
            <div className="text-5xl mb-3">🎉</div>
            <h2 className="text-green-600 font-bold text-lg">
              Email Verified Successfully
            </h2>

            <p className="text-gray-500 mt-2">
              You are now subscribed to our newsletter.
            </p>

            {/* Unsubscribe Button */}
            {/* <button
              onClick={handleUnsubscribe}
              className="mt-5 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-sm"
            >
              Unsubscribe
            </button> */}
          </div>
        )}

        {/* Error */}
        {status === "error" && (
          <p className="text-red-500">
            Invalid or expired verification link.
          </p>
        )}

        {/* Unsubscribed */}
        {status === "unsubscribed" && (
          <p className="text-gray-600 font-medium">
            You have unsubscribed successfully.
          </p>
        )}

      </div>
    </div>
  );
}